import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScheduled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			rx: 13,
			fill: "#E3F2FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.25 7H17.5V5.5H16V7H10V5.5H8.5V7H7.75C6.9175 7 6.2575 7.675 6.2575 8.5L6.25 19C6.25 19.825 6.9175 20.5 7.75 20.5H18.25C19.075 20.5 19.75 19.825 19.75 19V8.5C19.75 7.675 19.075 7 18.25 7ZM18.25 19H7.75V11.5H18.25V19ZM18.25 10H7.75V8.5H18.25V10ZM13 13.75H16.75V17.5H13V13.75Z",
			fill: "#1976D2"
		})
	]
});
const ForwardRef = forwardRef(SvgScheduled);
export default ForwardRef;
